import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Sorder } from 'src/app/assabil-sales/models/entities/s-order';
import { SalesTransactionsService } from 'src/app/assabil-sales/services/sales-transactions-service';



@Component({
    selector: 'sorder-list',
    templateUrl: './sorder-list.component.html',
    styleUrls: ['./sorder-list.component.scss']
})


export class SorderListComponent extends BasePage2<Sorder> {

    sorders         : Sorder[] = [];
    code            : string;
    partnerCode     : string;
    roleCode        : string;
    startDate       : Date;
    endDate         : Date;
    excludeClosed   : boolean = true;
    excludeCanceled : boolean = true;
    

    constructor(
        protected toastr                    : ToastrService,
        protected salesTransactionsService  : SalesTransactionsService,
        protected router            : Router,
        protected baseService       : BaseService,
        protected leanUtilsService  : LeanUtilsService, 
        protected location          : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'sorder';
    }

    ngAfterViewInit(){
        super.ngAfterViewInit();
        
        this.salesTransactionsService.sordersGet(null, null, null, null, null, this.excludeClosed, this.excludeCanceled).then(result => {
            this.sorders = result;
        })
    }

    getRows(): Sorder[] {
        return this.sorders;
    }

    saveRow(row: Sorder): Promise<Sorder> {
        return this. salesTransactionsService.sorderSave(row);
    }

    loadData() {
        this. salesTransactionsService.sordersGet(this.code, this.partnerCode, this.roleCode, this.startDate, this.endDate, this.excludeClosed, this.excludeCanceled).then(result => {
            this.sorders = result;
        }).catch(error => {
        })
    }

    newSorder(returnWt?: boolean) {
        let tmp          = new Sorder();
        // tmp.person       = new Person();
        // tmp.role         = new Role();
        // tmp.returnPo     = returnWt;
        // tmp.porderLines  = [];
        tmp.edit         = true; 
        tmp.inserted     = true; 
        this.selectedRow = tmp;
    }


    selectRow(sorder : Sorder){
        this.selectedRowIndex = this.sorders.indexOf(sorder);

        this.salesTransactionsService.sorderGet(sorder.sorderCode).then(result => {
          this.sorders[this.selectedRowIndex] = result;
          this.selectedRow = result; 
        })
    }

}
